'use client';

import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { usePathname } from '@/config';
import { Analytics } from '@/utils/analytics';

const PageLoadEventProvider = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      Analytics.trackEvent('page_view', { pathname });
    }
  }, [pathname]);

  return <>{children}</>;
};

export default PageLoadEventProvider;
